export const BASE_API_URL = process.env.REACT_APP_ENDPOINT

export const LOGIN_ENDPOINT = '/auth/login'
export const CREATE_LEAD_WITH_TOKEN_ENDPOINT = '/token/lead'
export const UPLOAD_CSV_ENDPOINT = '/import'
export const CHECK_TOKEN_ENDPOINT = '/verify'
